module.exports = __webpack_public_path__ + "static/media/team-img2.13f020a4.jpg";